module.exports = __webpack_public_path__ + "images/578b262978fc092f1ac253179f447e9d.jpg";